module.exports = __webpack_public_path__ + "static/media/check-svgrepo-com.802569cd.svg";